<template>
  <div>
    <div v-for="(visit, vind) in shownVisits"
         :key="`treat-visit-${visit.id}`">
      <div :id="`popover-complex-doctor-${visit.id}`">
        <CustomPopover :target="`popover-complex-doctor-${visit.id}`"
                       v-if="visit.doctor"
                       placement="top"
                       ref="popover"
                       :arrow="false">
          <div class="word-break">
            {{ $t('stage_doctor')}}: {{ visit.doctor.full_name }}
          </div>
        </CustomPopover>

        <span v-if="visit.manual_status" :class="{
        'circle-success': visit.manual_status === 'finished',
        'circle-warning': visit.manual_status === 'in_process',
        'circle-gray': visit.manual_status === 'new',
      }" class="circle sm mr-1"></span>
        {{ visit.title ? visit.title : $t('stage')+' '+(vind + 1) }}
        <span v-for="(t, tind) in visit.teeth"
              :key="`vt-${visit.id}-${tind}`">
        <span v-if="tind > 0">, </span>{{ t.tooth }}
      </span>
      </div>
    </div>


    <div v-if="hiddenVisits.length"
         :id="`obj-pop-${object.id || object.planning_id}`"
         class="text-muted small text-lowercase">
      +{{ hiddenVisits.length }} {{ $t('more_2') }}
    </div>

    <CustomPopover :target="`obj-pop-${object.id || object.planning_id}`"
                   v-if="hiddenVisits.length"
                   placement="top"
                   ref="popover"
                   :arrow="false">
      <div :key="`strs-${vind}`"
           v-for="(visit, vind) in hiddenVisits"
           class="word-break">
        {{ visit.title ? visit.title : $t('stage')+' '+((vind + limit) + 1) }}
      </div>
    </CustomPopover>
  </div>
</template>

<script setup>
import CustomPopover from "@/components/parts/calendar/CustomPopover.vue"
import {computed } from "vue"
import {useRoute} from "vue-router"

const props = defineProps({
  object: {
    type: Object
  }
})

const route = useRoute()

const limit = computed(() => {
  if(route.name === 'PatientTreatmentPlan') return 20
  return 5
})

const shownVisits = computed(() => {
  return (props.object?.visits || []).slice(0, limit.value)
})
const hiddenVisits = computed(() => {
  return (props.object?.visits || []).slice(limit.value)
})
</script>
